import { IStorageAccessor } from 'util/domain';

const NullStorage:Storage = {
    setItem: (key, value) => {},
    getItem: key => null,
    removeItem: key => {},
    length: 0,
    clear: () => {},
    key: (i) => null
};

const InMemoryStorage:Storage = (() => {
    var store:Object = Object.create(null);
    var keys:string[] = [];
    return {
        get length() {
            return Object.keys(store).length;
        },
        setItem: (key, value) => {
            store[key] = value.toString();
            keys = Object.keys(store);
        },
        getItem: key => key in store ? store[key] : '',
        removeItem: key => {
            store[key] = null;
            delete store[key];
            keys = keys.filter(k => k !== key);
        },
        clear: () => {
            Object.keys(store).forEach(this.removeItem)
        },
        key: (i:number) => {
            return keys[i] || '';
        }
    };
})();

class StorageAccessor implements IStorageAccessor {
    constructor(private provider:Storage) {
    }

    public setStoredValue(key:string, value:string){
        this.provider.setItem(key, value);
    }

    public getStoredValue(key:string){
        var val = this.provider.getItem(key);
        return val === null || !angular.isDefined(val) ? '' : val;
    }

    public removeStoredValue(key:string){
        this.provider.removeItem(key);
    }

    public removeStoredValues(...keys:string[]){
        keys.forEach(this.removeStoredValue);
    }
}

export class StorageFactory {  
    public static readonly NullStorage:IStorageAccessor = new StorageAccessor(NullStorage);
    public static readonly InMemoryStorage:IStorageAccessor = new StorageAccessor(InMemoryStorage);
    constructor(){}

    public create(sp:Storage) {
        return new StorageAccessor(sp);
    }    
}


// WEBPACK FOOTER //
// ./src/util/services/storageService.ts